import React, {useEffect, useState} from 'react';
import {Field as ReactField} from 'react-final-form';
import cn from 'classnames';

import {FieldValidation} from 'brandComponents/Form/Subcomponents/Field/types';

import {IFieldReactProps} from './IFieldReact';

const composeValidators = (validators: FieldValidation[]) => (value: string) => {
	let hasError = true;

	for (let i = 0, length = validators.length; i < length; ++i) {
		hasError = !validators[i].rule(value);

		if (hasError) {
			return validators[i].errorMessage;
		}
	}

	return null;
};

const Field = (
	{
		classNames,
		component,
		isErrorShown,
		validation,
		children,
		customIcon,
		onClick,
		ref,
		...props
	}: IFieldReactProps,
) => {
	const [key, setKey] = useState(null);
	const errorMessages = (validation && validation.length) ? validation.map(i => i.errorMessage).join('') : '';

	useEffect(() => {
		if (errorMessages) {
			// triggers field re-validation in case error message changed i.e. in case locale changed
			setKey(errorMessages);
		}

	}, [errorMessages]);

	return (
		<>
			<ReactField
				onClick={onClick ? (e) => onClick(e) : onClick}
				data={key}
				{...props}
				component={component}
				className={cn(classNames, {
					invalid: isErrorShown,
				})}
				validate={validation ? composeValidators(validation) : undefined}
				ref={ref}
			>
				{children}
			</ReactField>
			{customIcon && customIcon}
		</>
	);
};

Field.displayName = 'Field';

export default Field;
